import { render, staticRenderFns } from "./AppCoreHeaderLeft.vue?vue&type=template&id=16cd7b52&scoped=true&"
import script from "./AppCoreHeaderLeft.vue?vue&type=script&lang=js&"
export * from "./AppCoreHeaderLeft.vue?vue&type=script&lang=js&"
import style0 from "./AppCoreHeaderLeft.vue?vue&type=style&index=0&id=16cd7b52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cd7b52",
  null
  
)

/* custom blocks */
import block0 from "./AppCoreHeaderLeft.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16cd7b52')) {
      api.createRecord('16cd7b52', component.options)
    } else {
      api.reload('16cd7b52', component.options)
    }
    module.hot.accept("./AppCoreHeaderLeft.vue?vue&type=template&id=16cd7b52&scoped=true&", function () {
      api.rerender('16cd7b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/ui/header/AppCoreHeaderLeft.vue"
export default component.exports